import { IVersion } from 'src/interfaces/version.interface';

export class VersionModel implements IVersion {
  version?: number;

  get version_text() {
    return String(this.version).padStart(3, '0').split('').join('.');
  }

  public static fromJson(js: IVersion) {
    let obj = new VersionModel();
    obj.version = js.version;
    return obj;
  }
}
